import React, { memo } from 'react';
import { Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
  return createStyles({
    container: {
      height: '100vh',
      width: '100vw',
    },
  });
};

export interface IMainLayoutProps extends WithStyles<typeof styles> {
  children: React.ReactNode;
}

const MainLayout = ({ classes, children }: IMainLayoutProps) => {
  return <div className={classes.container}>{children}</div>;
};

export default memo(withStyles(styles)(MainLayout));
